import { STARTUP_MOUNT_EVENT } from "@/lib/startupWatchdog";

export const BOOT_SHELL_ID = "recipmon-boot-shell";
export const TELEGRAM_MINI_APP_PATH = "/recipmontelegram/";

type BootShellDocumentLike = Pick<Document, "getElementById">;
type BootShellWindowLike = Pick<Window, "addEventListener" | "removeEventListener">;

export type BootShellLifecycleController = {
  remove: () => void;
  detach: () => void;
};

export const hideBootShell = (
  documentRef: BootShellDocumentLike = document,
  bootShellId: string = BOOT_SHELL_ID,
) => {
  const bootShell = documentRef.getElementById(bootShellId);
  if (!bootShell) {
    return false;
  }

  bootShell.setAttribute("data-state", "hidden");
  bootShell.remove();
  return true;
};

export const attachBootShellLifecycle = ({
  windowRef = window,
  documentRef = document,
  startupMountEvent = STARTUP_MOUNT_EVENT,
  bootShellId = BOOT_SHELL_ID,
}: {
  windowRef?: BootShellWindowLike;
  documentRef?: BootShellDocumentLike;
  startupMountEvent?: string;
  bootShellId?: string;
} = {}): BootShellLifecycleController => {
  const onMounted = () => {
    hideBootShell(documentRef, bootShellId);
  };

  windowRef.addEventListener(startupMountEvent, onMounted, { once: true });

  return {
    remove: () => {
      hideBootShell(documentRef, bootShellId);
    },
    detach: () => {
      windowRef.removeEventListener(startupMountEvent, onMounted);
    },
  };
};

export const shouldRedirectTelegramRootToMiniApp = ({
  pathname,
  isTelegramContext,
}: {
  pathname: string;
  isTelegramContext: boolean;
}) => pathname === "/" && isTelegramContext;

export const buildTelegramMiniAppRedirectUrl = ({
  href,
  miniAppPath = TELEGRAM_MINI_APP_PATH,
}: {
  href: string;
  miniAppPath?: string;
}) => {
  const currentUrl = new URL(href);
  const nextUrl = new URL(miniAppPath, currentUrl.origin);
  nextUrl.search = currentUrl.search;
  nextUrl.hash = currentUrl.hash;
  return nextUrl.toString();
};
